<template>
    <modal
      :showModal="showModal"
      @close-modal="$emit('close-modal')"
      width="30"
    >
      <div class="py-5">
            <p class="flex justify-center pb-6"><img src="@/assets/images/fleet/truck-fleeet.svg" alt="Wallet icon" /></p>
            <p class="text-lg font-normal w-full text-center">Fleet Type</p>
            <p class="text-xs font-normal w-full text-center opacity-75">Choose preferred fleet type </p>
            <div class="flex justify-around items-center pt-8">
                <button class="py-2 px-3 bg-primary-yellow"
                @click="routeToAddVehicles('private')"
                >Private Fleet</button>
                <button disabled class="py-2 px-3 bg-primary-lightblue"
                @click="routeToAddVehicles('public')"
                >Public Fleet</button>
            </div>
      </div>
    </modal>
  </template>
  
  <script>
  
  export default {
    props: {
        showModal: Boolean,
    },
    data() {
      return {};
    },
    computed: {

    },
    methods: {
        routeToAddVehicles(val){
         this.$router.push(`/settings/vehicles/new/${val}`)
    },
      closeModal() {
        this.$emit("close-modal");
      },
    },
    mounted() {},
  };
  </script>
  
  <style scoped>
  .particulars-img-wrapper {
    /* border: 1px solid #edf2ef; */
    /* width: 60%; */
    /* margin: 1rem auto; */
    cursor: pointer;
  }
  
  .uploaded-img {
    width: 8rem;
    height: auto;
    margin: 1rem auto;
  }
  
  .el-date-editor.el-input {
    width: 100%;
    padding-right: 0;
  }
  </style>
  